import { render, staticRenderFns } from "./RatingEmoji.vue?vue&type=template&id=28e25762&"
import script from "./RatingEmoji.vue?vue&type=script&lang=ts&"
export * from "./RatingEmoji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports